import React, { useState, useEffect } from 'react';
import CountdownTimer from '../src/components/CountdownTimer/CountdownTimer.js';
import { doc, onSnapshot, Timestamp, updateDoc,getDoc } from 'firebase/firestore';
import { db } from './firebase';
import './App.scss';
import InfiniteScrollingList from './components/ScrollList/ScrollList.jsx';
import CountdownTimer2 from '../src/components/CountdownTimer2/CountdownTimer2.js';
import backgroundImage from './buylist.png';
import ThemeBackground from './components/Themes/LOTR/Background.png';
import ThemeOverlay from './components/Themes/LOTR/Overlay.png';
import PlayerList from './components/ScrollList/ScrollList.jsx';
import BackgroundRotator from './components/backgroundRotator/backgroundRotator.jsx';

function getTimePassed(timestamp) {
  let original_timestamp = timestamp.toDate();
  const current_timestamp = Timestamp.fromDate(new Date()).toDate();

  const dif = current_timestamp - original_timestamp;
  const diffInSecs = Math.round(dif / 1000);

  return diffInSecs;
}

function App() {


  const [time, setTime] = useState(0);
  const [countdown, setCountdown] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [evento, setEvento] = useState('');
  const [round, setRound] = useState([]);
  const [eventStep, setEventStep] = useState('');


  const [codigo, setCodigo] = useState('');
  const [event1Active, setEvent1Active] = useState(false);
  const [singleBackground1, setSingleBackground1] = useState({});
  const [dualBackground1, setDualBackground1] = useState({});
  const [players,setPlayers] = useState([])

  const [time2, setTime2] = useState(0);
  const [countdown2, setCountdown2] = useState(0);
  const [isRunning2, setIsRunning2] = useState(false);
  const [evento2, setEvento2] = useState('');
  const [round2, setRound2] = useState([]);
  const [eventStep2, setEventStep2] = useState('');
  const [codigo2, setCodigo2] = useState('');
  const [event2Active, setEvent2Active] = useState(false);
  const [singleBackground2, setSingleBackground2] = useState({});
  const [dualBackground2, setDualBackground2] = useState({});
  const [players2,setPlayers2] = useState([])

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'finalcountdown', 'finalcountdown'), (doc) => {
      console.log(doc.data().time);
      console.log(doc.data().countdown);

      let timer = getTimePassed(doc.data().createdAt);

      let calculatedTime;
      if (Number(doc.data().countdown) - timer < 0) {
        calculatedTime = 0;
      } else {
        calculatedTime = Number(doc.data().countdown) - timer;
      }

      setEventStep(doc.data().eventStep);
      setTime(Number(doc.data().time));
      setCountdown(calculatedTime);
      setIsRunning(doc.data().isRunning);
      setEvento(doc.data().evento);
      setRound(doc.data().jugadores);
      setCodigo(doc.data().codigo);
      setEvent1Active(doc.data().enabled);
      setSingleBackground1(doc.data().singleTheme);
      setDualBackground1(doc.data().dualTheme);
      setPlayers(doc.data().players)
    });

  const unsubSlides = onSnapshot(doc(db, 'slides', 'homepage'), (docSnap) => {
    if (docSnap.exists()) {
      const rawSlides = docSnap.data().images || [];
      const validSlides = rawSlides.filter((url) => typeof url === 'string' && url !== '__EMPTY__');
      setSlideImages(validSlides);
      setTimer(docSnap.data().timer || 10000);
    } else {
      setSlideImages([]);
    }
  });
  
    const unsub2 = onSnapshot(doc(db, 'finalcountdown', 'finalcountdown2'), (doc) => {
      let timer = getTimePassed(doc.data().createdAt);

      let calculatedTime2;
      if (Number(doc.data().countdown) - timer < 0) {
        calculatedTime2 = 0;
      } else {
        calculatedTime2 = Number(doc.data().countdown) - timer;
      }

      setEventStep2(doc.data().eventStep);
      setTime2(Number(doc.data().time));
      setCountdown2(calculatedTime2);
      setIsRunning2(doc.data().isRunning);
      setEvento2(doc.data().evento);
      setRound2(doc.data().jugadores);
      setCodigo2(doc.data().codigo);
      setEvent2Active(doc.data().enabled);
      setSingleBackground2(doc.data().singleTheme);
      setDualBackground2(doc.data().dualTheme);
      setPlayers2(doc.data().players)

    });

    return () => {
      unsub();
      unsub2();
      unsubSlides();
    };
  }, []);
const [slideImages, setSlideImages] = useState([]);
const [timer, setTimer] = useState(10000);

  const images = [
  "https://firebasestorage.googleapis.com/v0/b/tgpl-751c9.firebasestorage.app/o/images%2F1.png?alt=media&token=540e95dd-0d63-4ca1-b02d-eb4fa0e6c7ec",
  "https://firebasestorage.googleapis.com/v0/b/tgpl-751c9.firebasestorage.app/o/images%2FCalendar%20Slide.png?alt=media&token=35edd3f7-8cd7-4315-9a95-da38853bfdf2",
  "https://firebasestorage.googleapis.com/v0/b/tgpl-751c9.firebasestorage.app/o/images%2FTGP%20website%20slide.png?alt=media&token=8199b17f-46d2-41d5-84bf-8bd0c7724a8b"

  ];

  const visibleItems = 2; // Set the desired number of visible items

  async function stopCounter1() {
    setIsRunning(false);

    let ref = {
      createdAt: Timestamp.fromDate(new Date()),
      isRunning: false,
    };

    const washingtonRef = doc(db, 'finalcountdown', 'finalcountdown');
    await updateDoc(washingtonRef, ref);
  }

  async function stopCounter2() {
    setIsRunning2(false);

    let ref = {
      createdAt: Timestamp.fromDate(new Date()),
      isRunning: false,
    };

    const washingtonRef = doc(db, 'finalcountdown', 'finalcountdown2');
    await updateDoc(washingtonRef, ref);
  }
  console.log(eventStep)
  console.log(eventStep2)


  return (
    <div
      className="mainBod"
      style={{
  
        width: '100%',
        height: '100vh', // Set the desired height of the div
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'black',
        marginTop: 0,
      }}
    >
     <div>
 {event1Active === false && event2Active === false ? (
      <BackgroundRotator
        event1Active={false}
        event2Active={false}
        imageUrls={slideImages}
        interval={timer}     // show each image for 5 seconds
        fadeDuration={1000} // fade duration of 1 second
      />):''}
    </div>  
     
     
      <div
        className="eventBody"
        style={{
          display: event1Active === false ? 'none' : '',
          backgroundColor: event1Active === true ? '' : '#c9c8c7',
          backgroundImage:
            event1Active && !event2Active ? `url("https://firebasestorage.googleapis.com/v0/b/magic-palace-84a34.firebasestorage.app/o/themes%2Fcyclonic%20rift%2Fbackground%20(2).png?alt=media&token=802407bc-f5a9-4380-93a0-b8f4ff88e817")` : (event1Active && event2Active ? `url("https://firebasestorage.googleapis.com/v0/b/magic-palace-84a34.firebasestorage.app/o/themes%2Fragavan%2Fbackground%20(3).png?alt=media&token=844c50b0-4780-449b-8072-757428499ef1")` : ''),
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: '100%',
        }}
      >
        <div
          className="overlay"
          style={{
            display: event1Active === false ? 'none' : '',
            backgroundColor: event1Active === true ? '' : '#c9c8c7',
            backgroundImage:
              event1Active && !event2Active ? `url("https://firebasestorage.googleapis.com/v0/b/magic-palace-84a34.firebasestorage.app/o/themes%2Fcyclonic%20rift%2Foverlay.png?alt=media&token=653c4b07-7538-4ff5-a7b6-992522a13ff0")` : (event1Active && event2Active ? `url("https://firebasestorage.googleapis.com/v0/b/magic-palace-84a34.firebasestorage.app/o/themes%2Fragavan%2Foverlay%20(2).png?alt=media&token=d65c912f-9751-45ec-9b1d-e3b6ef56f251")` : ''),
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            height: '100%',
            zIndex:1
          }}
        ></div>

        <div className="outsideContainer">
          <div className="eventName">
            <div className='eve'>{evento}</div>
          </div>
        </div>

        <div className="outsideContainer">
          {eventStep === 'Standings' ? (
            <div style={{ zIndex: 2, marginTop:"10px" }}>
              <PlayerList players={players} scrollInterval={500} />
            </div>
          ) : (
            <div>
              <div className="outsideContainer">
                <div className="eventStep" style={{zIndex:2,position:"relative"}}>{eventStep}</div>
              </div>
              <div className="outsideContainer">
                <div className="CountdownTimer">
                  <div className="timerItself">
                    {eventStep === 'SignUp' ? (
                      <div className="eventCodeWrapper">
                        <div className="eventCode" style={{ fontSize: '3.8rem',zIndex:2,position:"relative"}}>
                          <div>{codigo}</div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <CountdownTimer
                          stopCounter1={stopCounter1}
                          countdown={countdown}
                          setCountdown={setCountdown}
                          isRunning={isRunning}
                          setIsRunning={setIsRunning}
                          resetTime={setTime}
                          time={time}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        className="eventBody"
        style={{
          display: event2Active === false ? 'none' : '',
          backgroundColor: event2Active === true ? '' : '#c9c8c7',
          backgroundImage:
            !event1Active && event2Active ? `url("https://firebasestorage.googleapis.com/v0/b/magic-palace-84a34.firebasestorage.app/o/themes%2Fcyclonic%20rift%2Fbackground%20(2).png?alt=media&token=802407bc-f5a9-4380-93a0-b8f4ff88e817")` : (event1Active && event2Active ? `url("https://firebasestorage.googleapis.com/v0/b/magic-palace-84a34.firebasestorage.app/o/themes%2Fkroxa%2Fbackground%20(1).png?alt=media&token=c19e3ce5-f662-4573-a458-62134b65fc43")` : ''),
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: '100%',
        }}
      >
        <div
          className="overlay"
          style={{
            display: event2Active === false ? 'none' : '',
            backgroundColor: event2Active === true ? '' : '#c9c8c7',
            backgroundImage:
              !event1Active && event2Active ? `url("https://firebasestorage.googleapis.com/v0/b/magic-palace-84a34.firebasestorage.app/o/themes%2Fkroxa%2Foverlay%20(1).png?alt=media&token=79929a01-9537-46f2-adc0-3649b5c7287d")` : (event1Active && event2Active ? `url("https://firebasestorage.googleapis.com/v0/b/magic-palace-84a34.firebasestorage.app/o/themes%2Fkroxa%2Foverlay%20(1).png?alt=media&token=79929a01-9537-46f2-adc0-3649b5c7287d")` : ''),
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            height: '100%',
          }}
        ></div>

        <div className="outsideContainer">
          <div className="eventName">
            <div className='eve'>{evento2}</div>
          </div>
        </div>
        <div className="outsideContainer">
          {eventStep2 === 'Standings' ? (
            <div style={{ zIndex: 2, marginTop:"10px" }}>
            <PlayerList players={players2} scrollInterval={500} />
            </div>
          ) : (
            <div>
              <div className="outsideContainer">
                <div className="eventStep">{eventStep2}</div>
              </div>
              <div className="outsideContainer">
                <div className="CountdownTimer">
                  <div className="timerItself">
                    {eventStep2 === 'SignUp' ? (
                      <div className="eventCodeWrapper">
                        <div className="eventCode" style={{ fontSize: '3.8rem' }}>
                          {codigo2}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <CountdownTimer2
                          stopCounter2={stopCounter2}
                          countdown={countdown2}
                          setCountdown={setCountdown2}
                          isRunning={isRunning2}
                          setIsRunning={setIsRunning2}
                          resetTime={setTime2}
                          time={time2}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div></div>
      </div>
    </div>
  );
}

export default App;
